import React from "react";
import {Link} from 'react-router-dom'

import "../SideBar/SideBar.css"
import { withMyDataContext } from "../../context/DataProvider";
import Aux from "../AuxFunctions";
import Fire from "../../config/Fire";
import Loader from "../Utilities/Loader";

const title = "topUsers"
const LIMIT = 20

class TopUsers extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showMore: false,
            usersData: [],
            isLoading: false,
        }
    }

    componentDidMount() {
        try {
            this.getAllData();
        } catch (error) {
            Aux.handleError(error)
        }
    }


    getAllData = async () => {
        if (this.state.isLoading) return;
        try {
            this.setState({ isLoading: true })
            Fire.shared
                .GetPostsData(title, null, LIMIT)
                .then(snapshot => {
                    if (snapshot) {
                        /*Aux.handleLog("started fetching...");
                        if (snapshot.length < LIMIT || snapshot.empty) {
                            this.setState({finished: true})
                        }*/
                        let data = snapshot.docs.map(document => {
                            const doc = document.data();
                            doc.id = document.id;
                            return doc;
                        });

                        this.setState({
                            usersData: [...this.state.usersData, ...data],
                            isLoading: false,
                        });

                    } else {
                        this.setState({ isLoading: false })
                    }
                });
        } catch (error) {
            Aux.handleError(error);
        }
    };

    handleClick = () => {
        this.setState((prevState) => ({ showMore: !prevState.showMore }));
    }


    usersRender = () => {
        //const numberOfItems = this.state.showMore ? this.state.menuItems.length : 5
        return (
                <div className="full-shadow " style={{width:"100%", marginTop:20, marginLeft:10, backgroundColor:"white", borderRadius:5, marginBottom:20}}>
                    <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                        <span className="side-bar-title-text " >
                            Top Users
                        </span>
                    </div>
                    <div className="cat-underline"></div>
                    {this.state.usersData.length !== 0 ?
                        this.state.usersData.map((item, i) => (
                            <TopUserRender key={i} user={item}></TopUserRender>
                        ))
                    : <Loader style={{margin:"20px 0"}}></Loader>}

                </div>
        );
    }

    

    goToProfile = (profile) => {
        try{
            this.props.history.push("/user/" + profile)
        }catch(error){
            Aux.handleError(error)
        }
    }

    render() {
        return (
            <div className="cat-container" style={{display: "flex"}}>
                <this.usersRender></this.usersRender>
            </div>
        );
    };

    
}
export default withMyDataContext((TopUsers));

class TopUserRender extends React.Component {
    render(){
        return (
        <div className="topbar-single-item-menu">
            <Link style={{display:"flex", justifyContent: "space-between", alignItems:"center", margin:15, textDecoration:"none"}} to={`/user/${this.props.user.username}`} >
                    <div style={{display:"flex", alignItems:"center", marginRight:20, overflow:"hidden"}} /* onClick={() =>{this.goToProfile(props.user.username)}} */>
                        {Aux.showAvatar(40, this.props.user.avatar,  this.props.user.username || "Unknown")}
                        <span className="user-text-underline side-bar-main-text" style={{marginLeft:10, /* fontWeight:"500", fontSize: 14, color: Colors.middleText,  overflowWrap:"anywhere" */}}>
                            {this.props.user.username || "Unknown"}
                        </span>
                    </div>
                
                    <div style={{display:"flex", alignItems:"center"}}>
                        <span className="side-bar-coins-text"/* style={{fontWeight:"bold", fontSize: 14, color: Colors.darkText }} */>
                            {this.props.user.coinsSpent || 0}$
                        </span>
                    </div>
            </Link>
        </div>
        )
    }
}